export default IconEscalatorUp => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-escalator-up" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M19.5 7h-2.672a2 2 0 0 0 -1.414 .586l-8.414 8.414h-2.5a2.5 2.5 0 1 0 0 5h3.672a2 2 0 0 0 1.414 -.586l8.414 -8.414h1.5a2.5 2.5 0 1 0 0 -5z" />
  <path d="M6 10v-7" />
  <path d="M3 6l3 -3l3 3" />
</svg>`;